import authenticate from '~/backend/authenticate';
import fetchCurrentUserConfigs from '~/backend/fetchCurrentUserConfigs';
import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import {initializeCurrentLocation} from "redux-little-router";
import {modify} from "mythil/object";
import {getCredentials} from "~/stateGetter";
import get from 'lodash/get';
import omit from 'lodash/omit';
import mapValues from "lodash/mapValues";
import { setConfig } from "../config";
import { getTranslator } from '~/translations';
import {getFallbackLanguage, getLanguage} from "~/stateGetter";
import { prepareMessages } from "~/data/dataPreparer";
import { pushFragments } from '~/actions/navigation_actions';



const actions = {
    setValue: (value, customParams = {}) => {
        return (dispatch, getState) => {
            dispatch({ type: 'authenticate_successfull', value: value, ...customParams });

            const initialLocation = getState().router;

            const state = { root: window.location.origin };
            const shouldPushFragments = history.state?.state?.root !== state.root && initialLocation.pathname !== '/';
            if (!shouldPushFragments) return dispatch(initializeCurrentLocation(initialLocation));

            const url = initialLocation.pathname + initialLocation.search + initialLocation.hash;
            dispatch(pushFragments(url, { forceChangeRootModel: true, replaceRoot: true  }, state));
        };
    }
};

let { reduce, execute, types, initialState,  } = createSuccessPromiseThunk({
    name: 'authenticate',
    actions,
    func: async ({dispatch, getState, getConfig, username, password, token}) => {
        let authResult = null;

        if(username && username.length && password && password.length) {
            authResult = (await authenticate(getConfig().baseUrl, username, password));
        } else if(token === true) {
            authResult = (await fetchCurrentUserConfigs(getConfig().baseUrl)) || {};
        } else {
            const state = getState();
            const trans = getTranslator(getLanguage(state),getFallbackLanguage(state));
            // TODO: add language var for this (we will refactor translation anyway so i was lazy)
            dispatch({ type: 'authenticate_errored', error: trans("loginPage.noCredentials") });
            return;
        }

        if(authResult.success) {
            const uniqueId = authResult.unique_id+'-'+authResult.user.user_id,
                companyTitle = authResult.company_title,
                locationName = authResult.location_name;

            window.Intercom?.('update', {
                app_id: 'gc6qyg0y',
                email: authResult.user.email,
                created_at: authResult.created_at,
                name: authResult.user.name,
                user_id:  uniqueId,
                phone: authResult.phone,
                company: companyTitle,
                website: window.location.href
            });
        } else {
            dispatch({ type: 'authenticate_errored', error: authResult.friendly_error });
            // throw new Error(authResult.friendly_error);
        }

        return authResult;
    },
    successHandler: ({dispatch, value, setValue, setErrored, customParams}) => {
        if(get(value, "unique_id")) {
            dispatch(setValue(value, customParams));
        }

        return true;
    }
});

let originalExecute = execute;
execute = (parameters = {}) => (dispatch, getState) => {
    let stateCredentials = getCredentials(getState());
    if(!parameters.username || !parameters.username.length) { parameters.username = stateCredentials.username }
    if(parameters.token !== true) { parameters.token = stateCredentials.token }

    return originalExecute(parameters, parameters)(dispatch, getState);
};

// TODO: adjust to new loading state
let originalReduce = reduce;
reduce = (state, action) => {
    switch(action.type) {
        case types.SUCCESS:
            const messages = (action.value.administrator_messages?.messages ?? []).map((message) => ({...message, scope: 'global'}))
            return {
                ...state,
                ...initialState,
                finished_at: Date.now(),
                value: {
                    authenticated: true,
                    messages: prepareMessages(messages)
                },
                error: null,
            };
        case types.ERROR:
            return {
                ...state,
                ...initialState,
                value: false,
                error: action.error,
            };
        default:
            return originalReduce(state, action);
    }
};

const reduceAuthState = (state, action) => {
      switch(action.type) {
          case types.SUCCESS:
                state = modify(state, 'credentials', {username: action.value.username});
                state = modify(state, 'availableModels', action.value.configNames);

                const settings = action.value.user.settings ? mapValues(action.value.user.settings, (model) => Array.isArray(model) ? {} : model) : {}
                state = modify(state, 'ui.settings', settings);
                state = modify(state, 'ui.sharedViews', action.value.sharedViews);
                state = modify(state, 'menu', action.value.menu);
                setConfig({ ...omit(action.value, "token", "accessToken", "refreshToken", "settings"), user: action.value.user })
              break;
      }

      return state;
};

export { types as AUTH_TYPES, reduce as reduceAuth, execute as authenticate, reduceAuthState };

// TODO: discuss this with Tobias. we will not be able to pass a token with a url any more.
export const ensureToken = () => {
    const token = new URL(window.location.href).searchParams.get('token');
    if (!token?.trim()) return;
    window.history.replaceState(null, "", window.location.href.split('?')[0]);
}
ensureToken();